import Button from "@mui/material/Button"
import DownloadIcon from "@mui/icons-material/Download"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import DialogActions from "@mui/material/DialogActions"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useLocation } from "react-router-dom"

export default function ManualDialog(props: {
  open: boolean,
  onClose: () => void,
}) {

  const location = useLocation()
  const matchResult = location.pathname.match(/^\/([^/]+)/)
  const targetPath = matchResult ? matchResult[1] : ''

  return targetPath === 'review' ?
    (
      <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
        <DialogTitle align="center">
          <Typography sx={{ fontSize: "24px", fontWeight: "bold" }}>
            活用方法の手引き
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>ご活用マニュアル(PDF)をダウンロードできます</Typography>
          <List sx={{ my: 2 }}>
            <ListItem sx={{ borderTop: 1, borderBottom: 1 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <Stack direction="row" gap={2}>
                  <PictureAsPdfIcon />
                  <Typography>口コミ・評価分析 LITE_ご活用マニュアル_20250410</Typography>
                </Stack>
                <Button
                  variant="contained"
                  color="info"
                  href="/review_manual.pdf"
                  target="_blank"
                  download="口コミ・評価分析 LITE_ご活用マニュアル_20250410.pdf"
                >
                  <DownloadIcon />
                  ダウンロード
                </Button>
              </Stack>
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.onClose}
            variant="contained"
            color="primary"
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    ) : (
      <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
        <DialogTitle align="center">
          <Typography sx={{ fontSize: "24px", fontWeight: "bold" }}>
            操作マニュアル
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>操作マニュアル(PDF)をダウンロードできます</Typography>
          <List sx={{ my: 2 }}>
            <ListItem sx={{ borderTop: 1, borderBottom: 1 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <Stack direction="row" gap={2}>
                  <PictureAsPdfIcon />
                  <Typography>買いログポータル_操作マニュアル_20260323</Typography>
                </Stack>
                <Button
                  variant="contained"
                  color="info"
                  href="/manual.pdf"
                  target="_blank"
                  download="買いログポータル_操作マニュアル_20260323.pdf"
                >
                  <DownloadIcon />
                  ダウンロード
                </Button>
              </Stack>
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.onClose}
            variant="contained"
            color="primary"
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    )
}
